import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-red-600 via-orange-500 to-amber-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
          Ready to Make Your Event Unforgettable?
        </h2>
        <p className="text-xl text-white/95 mb-10 leading-relaxed max-w-2xl mx-auto">
          Contact Fun Affairs today for a free quote on event entertainment rentals in Allentown, Bethlehem, Easton, and the Lehigh Valley. Let's make your celebration amazing!
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link 
            to="/contact" 
            className="bg-white text-red-600 px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap w-full sm:w-auto"
          >
            Get Your Free Quote
          </Link>
          <a 
            href="tel:6102532835" 
            className="bg-gray-900 text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-800 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-phone-fill mr-2"></i>
            (610) 253-2835
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 text-white">
          <div className="flex items-center space-x-2">
            <i className="ri-time-fill text-2xl"></i>
            <span className="font-semibold text-sm">Same-Day Available</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-fill text-2xl"></i>
            <span className="font-semibold text-sm">Licensed & Insured</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-star-fill text-2xl"></i>
            <span className="font-semibold text-sm">5-Star Rated</span>
          </div>
        </div>
      </div>
    </section>
  );
}